import { XCircleIcon } from '@heroicons/react/solid';

export type ErrorAlertProps = {
  text: string;
};

export function ErrorAlert({ text }: ErrorAlertProps) {
  return (
    <div className="w-full p-4 rounded-md bg-red-50 flex justify-between">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="w-5 h-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-red-700">{text}</p>
        </div>
      </div>
    </div>
  );
}
